var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nio-select',{ref:"select",attrs:{"options":_vm.sortedContacts,"search-enabled":true,"search-external":true,"search-loading":_vm.searching,"value":_vm.value},on:{"input":_vm.onInput,"search":_vm.onSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }